const featureItems = [
  {
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '91在线视频全面支持4K超清画质播放，多码率自适应，网络环境自动匹配最佳清晰度，观影体验不妥协。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速不缓冲',
    desc: '采用多CDN智能调度与P2P加速技术，影片加载速度提升40%，告别缓冲等待，点开即看无缝播放。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全设备适配',
    desc: 'PC、平板、手机全平台完美适配，移动端浏览器直接访问无需安装，随时随地畅享91视频资源。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '密桃视频内容团队每日精选更新，新片上线24小时内同步，91视频网站资源实时追踪，追剧永不错过。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全观影',
    desc: '平台搭载智能安全防护系统，无弹窗广告、无恶意跳转，为您提供纯净安全的久久视频观影环境。',
  },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2 justify-center">
          <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center">
            <i className="ri-medal-line text-primary-600 text-lg"></i>
          </div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">平台优势</h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10 text-center">为什么选择密桃视频？五大核心优势为您保驾护航</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {featureItems.map((item, i) => (
            <div
              key={i}
              className={`p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all cursor-default ${
                i === featureItems.length - 1 && featureItems.length % 3 !== 0
                  ? 'lg:col-span-3 lg:max-w-md lg:mx-auto'
                  : ''
              }`}
            >
              <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center mb-3">
                <i className={`${item.icon} text-primary-500 text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1.5">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}